// eslint-disable-next-line @typescript-eslint/no-unused-vars
import tw, { css, styled } from "twin.macro"

import { StickyNavProps } from "components/dynamic"

import { H6 } from "styles/Text"
import Container from "components/Container"

// styled components
const StyledStickyNav = styled.nav(() => [
  tw`
    hidden flex-wrap justify-center items-center 
    w-full h-25 px-4 bg-white
    border-0 border-b border-light-grey border-solid 
    sticky 
    z-40
    
    md:flex
  `,

  css`
    top: 112px;
  `,
])

const NavItems = tw.ul`
  text-black
  flex flex-wrap justify-center items-center 
  -mx-4 my-0 p-0
  list-none 
`

export const StickyNav = ({ Links }: StickyNavProps) => {
  return (
    <StyledStickyNav>
      <Container>
        <NavItems>
          {Links.map(({ Text, Anchor, id }) => (
            <li tw="mx-4" key={id + Text}>
              <H6 tw="py-2" as="a" href={`#${Anchor}`}>
                {Text}
              </H6>
            </li>
          ))}
        </NavItems>
      </Container>
    </StyledStickyNav>
  )
}

export default StickyNav
